<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Tz84jz/tc-custom/9781609459208.jpg?1726871176534" alt="This image is the cover for the book Minotaur"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Minotaur
      </h1>
      <p class="bookDescription body article font2">
        <b>“With echoes of Kafka and Conrad,” the acclaimed Israeli author of <i>Castle in Spain </i>offers “a provocative, spare, slow-to-unfold mystery of character” (<i>Kirkus Reviews</i>).</b><br/>  <br/> On the day of his forty-first birthday, Israeli secret agent Alexander Abramov encounters a beautiful young redhead on a city bus. He immediately recognizes her as the woman he has been searching for all his life, the one he has loved forever. Though they have never met, he is certain this young woman named Thea is an essential part of his life’s destiny.<br/>  <br/> Using all the tricks of his trade and communicating through anonymous letters, Abramov takes control of Thea’s life without ever revealing his identity. Soon, Abramov’s desperate, dangerous love for a woman half his age consumes everything in its path: time, distance, and rival suitors. And for Thea, keeping her lover safe from the amorous “Mr. Anonymous” becomes an obsession of her own. Only Abramov’s own story, of a life conditioned by isolation, distrust, violence, and murder, can explain his devastating manipulation of the woman he professes to love.<br/>  <br/> Hailed by Graham Greene as “the best novel of the year” upon its initial release in 1981, <i>Minotaur </i>is a highly inventive literary thriller.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Benjamin Tammuz, Kim Parfitt, Mildred Budny
      </h2>
      
      <p class="authorDescription body article">Benjamin Tammuz was born in Russia in 1919 and immigrated to Palestine with his family at the age of five. He was a sculptor as well as a diplomat, a writer, and, for many years, literary editor of the Ha’aretz newspaper. His numerous novels and short stories have been widely translated from the Hebrew and have received several literary prizes. He died in 1989.Translated from the Hebrew by Mildred Budny and Kim Parfitt.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bf924c6